import React, { createContext, useState } from "react";

const SimulationContext = createContext({});

export const SimulationProvider = ({ value, children }) => {
    const initState = ((process.env?.NODE_ENV === 'development') && process.env?.REACT_APP_MOCK_SIMSTATE) ? 
        JSON.parse(process.env?.REACT_APP_MOCK_SIMSTATE) :
        {
            currentStep: 0,
            completeSteps: 0,
            location: {
                formatted: null,
                components: null,
                location: null
            },
            adjustedLocation: null,
            orientation: null,
            surface: {
                area: null,
                drawing: null
            },
            infos: null,
            contact: null,
            video_play: null
        };
    const [parameters, setParameters] = useState(initState);

    return <SimulationContext.Provider value={[parameters, setParameters]}>{children}</SimulationContext.Provider>;
};

export default SimulationContext;